export default __webpack_public_path__ + "img/go-to-top-btn.53073cf64a5cbb87814f051d52b9eaea.svg";